module.exports = __webpack_public_path__ + "img/查询.040f1b49.svg";